<template>
    <div class="">
        <!-- <div class="area"> -->
        <div >
            <h5>Paso 2: [Opcional] Ordene el contenido según su prioridad y guarde los cambios</h5>
            <hr />
            <div class="listaOrdenable_div row-5">
                <ListaOrdenableDeContenido></ListaOrdenableDeContenido>
            </div>
        </div>
        <div class="text-right">
            <div style="text-align">
                <br>
<div style="background-color:blue">
<label  class="titulo-switch">Ordenar Alfabeticamente</label>
        <div class="switch-button" >
             
            <input type="checkbox" name="switch-button" id="switch-label" class="switch-button__checkbox" @click="ordenDeContenidosAlfabeticos()">
            <label for="switch-label" class="switch-button__label"></label>
        </div>
</div>
        <div>
               
                <button type="button" class="btn btn-primary text-center" data-toggle="modal" data-target="#exampleModal" @click="guardarOrdenDeContenidos()">Guardar Orden</button>
            </div> 
           
            </div> 
        </div>  
    </div>  
</template>

<script>
    import enumeraciones from '@/../static/js/enumeraciones'
    import api from '@/../static/js/api'
    import comun from '@/../static/js/comun'
    import axios from 'axios'
    import ListaOrdenableDeContenido from '@/components/SICPO/Micrositios/ListaOrdenableDeContenidoMicrositio.vue'

    export default {
        components: {
            ListaOrdenableDeContenido
        },
        data() {
            return {
                ordenarAlfabeticamente:false,
                mostrarDescripcionDeIconos: false,
                ordenEditadoBandera: false,
                listaDeContenidosNuevoOrden: []
            };
        },
        methods: {
            ordenDeContenidosAlfabeticos: function(){
                 this.ordenarAlfabeticamente = !this.ordenarAlfabeticamente;
                var listado=this.obtenerListaDeContenidosOriginal
                // console.log(listado)
                if(this.ordenarAlfabeticamente){
                    listado.sort(function (a, b) {    
                        //  console.log("texto vinculo aaa "+a.contenido.TextoDelVinculo+" texto vinculo bbb "+b.contenido.TextoDelVinculo)
                        // console.log(a.contenido.TextoDelVinculo.localeCompare(b.contenido.TextoDelVinculo))
                        return a.contenido.TextoDelVinculo.localeCompare(b.contenido.TextoDelVinculo);
                         })

                }
               if(!this.ordenarAlfabeticamente){
                    listado.sort(function (a, b) {    
                //    console.log("texto vinculo aaa "+a.contenido.TextoDelVinculo+" texto vinculo bbb "+b.contenido.TextoDelVinculo)
                //         console.log(a.contenido.TextoDelVinculo.localeCompare(b.contenido.TextoDelVinculo))
                        return b.contenido.TextoDelVinculo.localeCompare(a.contenido.TextoDelVinculo);
                         })
               }

               this.$store.dispatch("A_SICPO_Micrositio_establecerOrdenAlfabetico",this.ordenarAlfabeticamente);

            
               //  this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal",listado);
            },
            /**
             * Metodo encargado de modificar el orden de los contenidos guardados en base de datos..  
             */
            guardarOrdenDeContenidos: function() {
                comun.SeEstaCargandoInformacion(true);
                this.generarListadoConNuevoOrden();
                               
                 const parametros = {}
                 parametros.ContenidosDelMicrositio = this.listaDeContenidosNuevoOrden;
                 parametros.SeccionDelMicrositioId =  this.$store.getters.Get_SICPO_Catalogo_014SeccionMicrositio.catalogoSeccionPasoUno;
                 parametros.EsPrueba = false;

                
                 const METODO_API_AGREGAR = api.SICPO.sistema.micrositioweb.altadecontenidomicrositio.ModificarOrdenContenidoMicrositio;;

                 axios.post(api.conexion + METODO_API_AGREGAR,parametros,comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal)).then(respuesta => {
                     comun.SeEstaCargandoInformacion(false);
                     if (respuesta.data.SiHayError) {
                         console.log(respuesta); 
                        comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                     } 
                     else {
                        //this.$store.dispatch("A_SICPO_PaginaWeb_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                        this.$store.dispatch("A_SICPO_Micrositio_AltaDeContenido_establecerCambioOrdenlistaContenidos",false);
                        comun.mensajeDeAlerta(respuesta.data.Satisfactorio, null, null);
                     }
                 }).catch(excepcion => {
                     comun.SeEstaCargandoInformacion(false);
                     console.log(excepcion);
                     comun.mensajeDeAlerta(comun.mensajeDeError(enumeraciones.error.E500), null, null);
                 });
            },
            /**
             * Metodo encargado de asignar el nuevo orden que tendra cada uno de los contenidos de la lista, desplazando
             * un lugar antes o despues segun la interaccion del usuario.  
             */
            generarListadoConNuevoOrden: function() {
                this.listaDeContenidosNuevoOrden = [];
                let listado = this.obtenerListaDeContenidosOriginal;
                
                var j = listado.length;
                for(var i=0;i<listado.length;i++){
                    
                    let contenido = listado[i].contenido;
                    contenido.OrdenDelContenido = j;
                    this.listaDeContenidosNuevoOrden.push(contenido);
                    j--;
                }
               
            },

           
        },
        mounted() {
            this.ordenarAlfabeticamente = this.$store.getters.Get_SICPO_Micrositio_establecerOrdenAlfabetico;
            $('#switch-label').prop('checked',this.ordenarAlfabeticamente);
        },
        
        computed: {
           
            obtenerListaDeContenidosOriginal() {
             
                return this.$store.getters.Get_SICPO_Micrositio_AltaDeContenido_listaContenidoOriginal;
                 
            },
           
        }
    }
</script>

<style scoped>

          .titulo-switch{
            font-size: 1.5rem;
           
            position: relative;
            float: left;
            margin-right: 1rem;
          }
            .switch-button {
                
                 float: left;
            }
            .switch-button .switch-button__checkbox {
                display: none;
            }
            .switch-button .switch-button__label {
                background-color: red;
                width: 4rem;
                height: 2rem;
                border-radius: 3rem;
                display: inline-block;
                position: relative;
            }
            .switch-button .switch-button__label:before {
                transition: .2s;
                display: block;
                position: absolute;
                width: 2rem;
                height: 2rem;
                background-color: white;
                content: '';
                border-radius: 50%;
                box-shadow: inset 0px 0px 0px 1px white;
            }
            .switch-button .switch-button__checkbox:checked + .switch-button__label {
                background-color: green;
            }
            .switch-button .switch-button__checkbox:checked + .switch-button__label:before {
                transform: translateX(2rem);
            }



    .listaOrdenable_div
    {
        background-color: #57585B;
        padding: 0.5%;
        min-height: 300px;
        max-height: 700px;
        overflow: auto;
        border-style: solid;
        border-color: #57585B;
        border-width: 1px;
        border-bottom-width: 3px;
    }
    .container-btn {
        display: flex;                             
        justify-content: space-between; 
    }
    .fa-caret-down:hover{
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// src/components/SICPO/Micrositios/Comun/CFormularioPasoTresMicrositio.vue